import { Routes } from '@angular/router';
import { pendingChangesGuard } from './core/pending-changes.guard';
import { adminGuard } from './core/admin.guard';
import { anyRoleGuard } from './core/any-role.guard';

export const routes: Routes = [
  {
    // Email login for exception accounts. Nothing links here; everyone else logs in via Cognito.
    path: 'admin-login',
    title: 'Kirjautuminen',
    loadComponent: () =>
      import('./features/auth/admin-login.component').then(
        (component) => component.AdminLoginComponent,
      ),
  },
  {
    path: 'salasana-uusiksi',
    title: 'Salasanan vaihto',
    loadComponent: () =>
      import('./features/auth/password-reset.component').then(
        (component) => component.PasswordResetComponent,
      ),
  },
  {
    path: 'auth/finish',
    title: 'Kirjautuminen',
    loadComponent: () =>
      import('./features/auth/cognito-finish.component').then(
        (component) => component.CognitoFinishComponent,
      ),
  },
  {
    path: 'ei-oikeutta',
    title: 'Ei käyttöoikeutta',
    loadComponent: () =>
      import('./features/auth/access-denied.component').then(
        (component) => component.AccessDeniedComponent,
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'saadokset',
  },
  {
    path: 'saadokset',
    title: 'Säädökset',
    loadComponent: () =>
      import('./features/statute-cards/statute-cards-browse.component').then(
        (component) => component.StatuteCardsBrowseComponent,
      ),
  },
  {
    path: 'saadokset/rt/:identifier',
    title: 'Säädös',
    loadComponent: () =>
      import('./features/statute-cards/legacy-statute-card-redirect.component').then(
        (component) => component.LegacyStatuteCardRedirectComponent,
      ),
    canActivate: [anyRoleGuard],
  },
  {
    // EU acts moved to Lakimonitori. Must precede saadokset/:year/:number, which would otherwise
    // match "eu" as a year.
    path: 'saadokset/eu/:celex',
    redirectTo: '/saadokset',
  },
  {
    path: 'saadokset/:year/:number/versiot/:version',
    title: 'Säädös',
    loadComponent: () =>
      import('./features/statute-cards/statute-card-page.component').then(
        (component) => component.StatuteCardPageComponent,
      ),
    canActivate: [anyRoleGuard],
  },
  {
    path: 'saadokset/:year/:number',
    title: 'Säädös',
    loadComponent: () =>
      import('./features/statute-cards/statute-card-page.component').then(
        (component) => component.StatuteCardPageComponent,
      ),
    canActivate: [anyRoleGuard],
  },
  {
    path: 'hallinta',
    title: 'Työjono – Hallinta',
    loadComponent: () =>
      import('./features/admin/admin-dashboard.component').then(
        (component) => component.AdminDashboardComponent,
      ),
    canActivate: [adminGuard],
  },
  {
    path: 'hallinta/luokittelu',
    title: 'Luokittelu – Hallinta',
    loadComponent: () =>
      import('./features/admin/category-admin.component').then(
        (component) => component.CategoryAdminComponent,
      ),
    canActivate: [adminGuard],
  },
  {
    path: 'hallinta/saadokset/:year/:number',
    // The router sets the title after the page is created, so it must name the statute itself.
    title: (route) =>
      `${route.paramMap.get('number') ?? ''}/${route.paramMap.get('year') ?? ''} – Säädöksen hallinta`,
    loadComponent: () =>
      import('./features/statute-cards/statute-card-control.component').then(
        (component) => component.StatuteCardControlComponent,
      ),
    canDeactivate: [pendingChangesGuard],
    canActivate: [adminGuard],
  },
  {
    path: 'vertailu',
    title: 'Vertailu',
    loadComponent: () =>
      import('./features/comparison/comparison-page.component').then(
        (component) => component.ComparisonPageComponent,
      ),
    canActivate: [adminGuard],
  },
  {
    path: 'omat-tiedot',
    title: 'Omat tiedot',
    loadComponent: () =>
      import('./features/profile/profile.component').then(
        (component) => component.ProfileComponent,
      ),
    canActivate: [anyRoleGuard],
  },
  {
    path: 'about',
    title: 'Tietoa palvelusta',
    loadComponent: () =>
      import('./features/about/about.component').then((component) => component.AboutComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
